import script from "./CategoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryPage.vue?vue&type=script&setup=true&lang=js"

import "./CategoryPage.vue?vue&type=style&index=0&id=646ca292&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646ca292"]])

export default __exports__